import React from "react";
import cn from "classnames";
import BaseButton from "./BaseButton";
import styles from "./SquareButton.module.scss";

type SquareButtonColor = "light-blue" | "mint" | "royal-blue" | "white" | "outline" | "secondary-100" | "accent3";

interface SquareButtonProps {
    color?: SquareButtonColor;
    className?: string;
    disabled?: boolean;
    href?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void;
    type?: string;
    target?: string;
}

const colorClasses = {
    "royal-blue": styles.royalBlueButton,
    "light-blue": styles.lightBlueButton,
    mint: styles.mintButton,
    white: styles.whiteButton,
    outline: styles.outlineButton,
    "secondary-100": styles.secondary100Button,
    "accent3": styles.accent3Button
};

/**
 * Square Button
 *
 * Renders a square button as a \<button> by default.
 * If an href prop is passed in, component will render as an \<a> instead
 */
const SquareButton = (props: React.PropsWithChildren<SquareButtonProps>) => {
    const {
        children, className, color = "royal-blue", ...restProps
    } = props;

    const colorClass = colorClasses[color];
    const classNames = cn(styles.button, colorClass, className);

    return (
        <BaseButton className={classNames} {...restProps}>
            {children}
        </BaseButton>
    );
};

export { SquareButton as default };
export type { SquareButtonProps, SquareButtonColor };
